import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as organizationOffering from '../../../../organization-offering'
import * as innovationIdea from '../innovation-idea'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: innovationIdea.RESOURCE.payload.dimension.partialId,
      partialId: innovationIdea.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Organization Offering connected to an Innovation Idea',
    isOptional: true,
    name: 'Organization Offering',
    partialId: PartialId.Standard.create('org_offering'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        organizationOffering.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
